import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from "react";
import BryxDumbSearchBar from "./BryxDumbSearchBar";
const BryxSmartSearchBar = (props) => {
    const [value, setValue] = useState("");
    function handleChange(e) {
        typeof props.hookChange != "undefined" && props.hookChange(e.target.value);
        setValue(e.target.value);
    }
    function handleClear() {
        setValue("");
        typeof props.hookChange != "undefined" && props.hookChange("");
        typeof props.hookClear != "undefined" && props.hookClear();
    }
    return (_jsx(BryxDumbSearchBar, { sx: props.sx, inputRef: props.inputRef, placeholder: props.placeholder ?? "Search...", className: props.className, onChange: handleChange, onClear: handleClear, value: value, customHeight: props.customHeight, customWidth: props.customWidth, autoFocus: props.autoFocus }));
};
export default BryxSmartSearchBar;
